import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth.guard';
import { OrderSalesListComponent } from './ordersales-list/ordersales-list.component';
import { OrderSalesStep1Component } from './ordersales-step1/ordersales-step1.component';
import { OrderSalesStep1ListComponent } from './ordersales-step1-list/ordersales-step1-list.component';
import { OrderSalesStep2ListComponent } from './ordersales-step2-list/ordersales-step2-list.component';
import { OrderSalesStep3ListComponent } from './ordersales-step3-list/ordersales-step3-list.component';
import { OrderSalesStep4ListComponent } from './ordersales-step4-list/ordersales-step4-list.component';
import { OrderSalesStep5ListComponent } from './ordersales-step5-list/ordersales-step5-list.component';

const routesOrderSales: Routes = [
    { path: 'ordersales-gcv-step1', component: OrderSalesStep1Component, canActivate: [AuthGuard] },
    { path: 'ordersales-gcv-step1-list', component: OrderSalesStep1ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcv-step2-list', component: OrderSalesStep2ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcv-step3-list', component: OrderSalesStep3ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcv-step4-list', component: OrderSalesStep4ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcv-step5-list', component: OrderSalesStep5ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcv-monitoring', component: OrderSalesListComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routesOrderSales)],
  exports: [RouterModule],
})

export class OrderSalesRoutingModule { }